import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Filter, Header } from "./component";
import { Tab, Nav } from "react-bootstrap";
import { TotalTabs } from "./component/ACDtabs";
import { useLocation } from "react-router-dom";
import {
  getACDTotalDashboardReport,
  fetchConfigurations,
  exportProgramWiseACDReport,
} from "actions";
import { isEmpty } from "lodash";

const TotalDashboard = () => {
  const [activeKey, setActiveKey] = useState("all");

  const dispatch = useDispatch();
  const location = useLocation();

  const { direction } = useSelector((state) => state.configurationState.lists);
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  useEffect(() => {
    if (
      session.current_page_permissions &&
      session.current_page_permissions.page_url === location.pathname &&
      object_viewed_id
    ) {
      dispatch(
        fetchConfigurations("direction", {
          object_viewed_id,
        }),
      );
    }
  }, [
    dispatch,
    location.pathname,
    object_viewed_id,
    session.current_page_permissions,
  ]);

  const tabTitles = useMemo(() => {
    const titles = { all: "All" };
    if (direction) {
      direction.forEach((dir) => {
        titles[dir.id] = dir.value;
      });
    }
    return titles;
  }, [direction]);

  const currentTitle = tabTitles[activeKey] || "";

  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {
      year: new Date().getFullYear(), // Default to current year
      month: new Date().getMonth() + 1, // Default to current month
      program_id: [],
      selectedDate: null,
      formatDate: "",
    },
  });

  const handleTotalDashboardReportFilter = () => {
    // Guard: Do not dispatch if object_viewed_id is not ready
    if (!object_viewed_id) {
      return;
    }
    const direction_ids = activeKey === "all" ? ["all"] : [activeKey];
    dispatch(
      getACDTotalDashboardReport({
        ...extraFiltersState.values,
        object_viewed_id,
        direction_ids,
      }),
    );
  };

  const handleFilter = () => {
    handleTotalDashboardReportFilter();
  };

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, object_viewed_id]);

  const handleExport = () => {
    if (!object_viewed_id) {
      return;
    }
    dispatch(
      exportProgramWiseACDReport({
        ...extraFiltersState.values,
        object_viewed_id,
      }),
    );
  };

  return (
    <div className="wrapper-div">
      <Header
        onFilter={handleFilter}
        handleExport={handleExport}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <Filter
        onFilter={handleFilter}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <div className="p-3">
        <div className="view-container">
          <Tab.Container
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
          >
            {/* Top Nav Tabs */}
            <h4 className="font-16 font-weight-medium m-0 pt-3 px-3">
              {currentTitle}
            </h4>
            <div className="d-flex justify-content-between align-items-center p-3">
              <Nav
                variant="tabs"
                activeKey={activeKey}
                onSelect={(k) => setActiveKey(k)}
              >
                <Nav.Item>
                  <Nav.Link eventKey="all">All</Nav.Link>
                </Nav.Item>
                {!isEmpty(direction) &&
                  direction.map((dir) => (
                    <Nav.Item key={dir.id}>
                      <Nav.Link eventKey={dir.id}>{dir.value}</Nav.Link>
                    </Nav.Item>
                  ))}
              </Nav>
            </div>

            {/* Tab Content */}
            <div>
              <Tab.Content>
                <Tab.Pane eventKey="all">
                  <TotalTabs
                    direction_id="all"
                    extraFiltersState={extraFiltersState}
                  />
                </Tab.Pane>
                {!isEmpty(direction) &&
                  direction.map((dir) => (
                    <Tab.Pane key={dir.id} eventKey={dir.id}>
                      <TotalTabs
                        direction_id={dir.id}
                        extraFiltersState={extraFiltersState}
                      />
                    </Tab.Pane>
                  ))}
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

export default TotalDashboard;
